import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import '@shui/core/sh-icon';
import '@shui/core/sh-toggle';

export interface ConfirmDialogData {
    /** Translation key for the dialog header. */
    title: string;
    /** Translation key for the body text. */
    message: string;
    /** Translation key of the confirming button, defaults to a plain "Confirm". */
    confirmLabel?: string;
    /** Translation key of the dismissing button, defaults to a plain "Cancel". */
    cancelLabel?: string;
    /** Interpolation parameters passed to `title`, `message` and the toggle label. */
    params?: Record<string, unknown>;
    /** Read-only toggle above the message, previewing the setting that is about to change. */
    toggle?: { label: string; active: boolean };
    confirmTestId?: string;
}

/** Generic yes/no dialog. Resolves to `true` when confirmed, `false` or `undefined` otherwise. */
@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    imports: [TranslateModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ConfirmDialogComponent {
    private readonly dialogRef = inject<MatDialogRef<ConfirmDialogComponent, boolean>>(MatDialogRef);

    protected readonly data = inject<ConfirmDialogData>(MAT_DIALOG_DATA);

    protected cancel(): void {
        this.dialogRef.close(false);
    }

    protected confirm(): void {
        this.dialogRef.close(true);
    }
}
